var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegalBackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72042 0.300601C6.34765 -0.100201 5.74326 -0.100201 5.37049 0.300601L0.27958 5.77428C-0.0931931 6.17509 -0.0931931 6.82491 0.27958 7.22571L5.37049 12.6994C5.74326 13.1002 6.34765 13.1002 6.72042 12.6994C7.09319 12.2986 7.09319 11.6488 6.72042 11.248L2.30448 6.5L6.72042 1.75203C7.09319 1.35123 7.09319 0.701402 6.72042 0.300601Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalBackIcon);
export default __webpack_public_path__ + "static/media/legalBackIcon.379c16d57a2fc1b90ed693c0c61da42b.svg";
export { ForwardRef as ReactComponent };